import {
  ActionGroup,
  Button,
  Form,
  FormFieldGroupHeader,
  FormGroup,
  Grid,
  GridItem,
  Panel,
  PanelHeader,
  PanelMain,
  PanelMainBody,
  Popover,
  Radio,
  Stack,
  StackItem,
  TextInput,
} from '@patternfly/react-core'

import DatetimeRangePicker from '../../components/calendar/DatetimeRangePicker'

import { FormEvent, FormEventHandler, useState } from 'react'
import Page from '../shared/Page'

const ComponentTest = () => {
  const [isNavOpen, setNavOpen] = useState(true)

  const [north, setNorth] = useState(0)
  const [west, setWest] = useState(0)
  const [south, setSouth] = useState(0)
  const [east, setEast] = useState(0)

  const [year, setYear] = useState(0)
  const [month, setMonth] = useState(0)

  const dtNow = new Date()
  const maxDate = new Date(dtNow.getFullYear(), dtNow.getMonth() - 1, 1)

  const [tsIn, setTsIn] = useState(new Date(dtNow.getFullYear(), dtNow.getMonth() - 3, 1))
  const [tsFin, setTsFin] = useState(maxDate)

  return (
    <Page
      pageName='Download de Dados Era5'
      isNavOpen={isNavOpen}
      setNavOpen={setNavOpen}
      isContentLoading={false}
      isLoading={false}
    >
      <Panel>
        <PanelHeader>Download de Dados Era5</PanelHeader>
        <PanelMain>
          <PanelMainBody>
            <Form>
              <Stack hasGutter>
                <span>Coordenadas</span>
                <StackItem>
                  <Grid hasGutter>
                    <GridItem lg={6}>
                      <FormGroup label='Norte' isRequired fieldId='north'>
                        <TextInput
                          type='number'
                          id='north-coordinate'
                          name='Coordenada Norte'
                          value={north}
                          onChange={e => setNorth(Number(e.currentTarget.value))}
                        />
                      </FormGroup>
                      <FormGroup label='Oeste' isRequired fieldId='west'>
                        <TextInput
                          type='number'
                          id='west-coordinate'
                          name='Coordenada Oeste'
                          value={west}
                          onChange={e => setWest(Number(e.currentTarget.value))}
                        />
                      </FormGroup>
                    </GridItem>
                    <GridItem lg={6}>
                      <FormGroup label='Sul' isRequired fieldId='south'>
                        <TextInput
                          type='number'
                          id='south-coordinate'
                          name='Coordenada Sul'
                          value={south}
                          onChange={e => setSouth(Number(e.currentTarget.value))}
                        />
                      </FormGroup>
                      <FormGroup label='Leste' isRequired fieldId='east'>
                        <TextInput
                          type='number'
                          id='east-coordinate'
                          name='Coordenada Leste'
                          value={east}
                          onChange={e => setEast(Number(e.currentTarget.value))}
                        />
                      </FormGroup>
                    </GridItem>
                  </Grid>
                </StackItem>

                <span>Período</span>
                <StackItem>
                  <DatetimeRangePicker
                    value={{ startDate: tsIn, endDate: tsFin }}
                    onChange={(newStart: Date, newEnd: Date) => {
                      setTsIn(newStart)
                      setTsFin(newEnd)
                    }}
                    calendarVariant='month'
                    maxEnabled={maxDate}
                    allowEqualDates={true}
                    variant='simple'
                  />
                </StackItem>
                <StackItem>
                  <ActionGroup>
                    <Button variant='primary'>Submit</Button>
                    <Button variant='link'>Cancel</Button>
                  </ActionGroup>
                </StackItem>
              </Stack>
            </Form>
          </PanelMainBody>
        </PanelMain>
      </Panel>
    </Page>
  )
}

export default ComponentTest
